import { render } from "./SubHeader.vue?vue&type=template&id=09bfd536&scoped=true"
import script from "./SubHeader.vue?vue&type=script&lang=js"
export * from "./SubHeader.vue?vue&type=script&lang=js"

import "./SubHeader.vue?vue&type=style&index=0&id=09bfd536&lang=scss&scoped=true"

import exportComponent from "/Users/parasagrawal/projects/twitter-helpdesk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bfd536"]])

export default __exports__